import { useEffect, useState } from "react";
import { useCookies } from 'react-cookie';
import { useNavigate } from 'react-router-dom';
import { useMyStore } from "./common/store/AppStoreProvider";
import { GetUsageComponent } from "./components/get_usage";
import { Address } from './types';

export const GetUsage = ({ handleClose }: { handleClose?: Function }) => {
    const navigate = useNavigate();
    const [cookies, setCookie, removeCookie] = useCookies(['consent_id']);
    const { getAddress } = useMyStore()
    const [storeAddress, setStoreAddress] = useState<Address>({} as Address)
    const { street: address, esiid, zipcode, city, state, utcode } = storeAddress

    useEffect(() => {
        if (!getAddress().esiid) {
            return
        }
        setStoreAddress(getAddress())
    }, [])

    return (
        <>
            <div className="container-md">
                <GetUsageComponent
                    defaultView={'smt'}
                    fetchActualUsage={() => {
                        navigate(`/plans?address=${encodeURIComponent(`${address}`)}&esiid=${esiid}&zipcode=${zipcode}&city=${city}&state=${state}&utcode=${utcode}`);
                    }}
                    handleSetConsentId={(id: string) => {
                        setCookie('consent_id', id, { path: '/', maxAge: 3600 });
                    }}
                    zipcode={`${zipcode}`}
                    forcastUsage={() => {
                        navigate(`/plans?address=${encodeURIComponent(`${address}`)}&esiid=${esiid}&zipcode=${zipcode}&city=${city}&state=${state}&utcode=${utcode}`);
                    }}
                    handleClose={()=>{handleClose && handleClose();console.log('GetUsageComponent')}}
                />
            </div>
        </>
    )
}